import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/theme.css"; // Système de thème multi-marques (white-label)
import "./styles/responsive-crm.css";
import "./i18n"; // Configuration i18n pour les traductions
import App from "./App";
import brand, { BRAND_KEY } from "./config/brand";
import { installFetchInterceptor } from "./lib/fetchInterceptor";

// Intercepteur fetch centralisé : injection auth pour notre backend (prérequis S4).
installFetchInterceptor();

// Applique la marque active (data-brand) -> sélectionne le thème CSS.
// Défaut "asar" : aucune modification de l'identité existante.
document.documentElement.setAttribute("data-brand", BRAND_KEY);

// Applique les métadonnées de marque (titre d'onglet, favicon, description) au runtime.
const applyBrandMeta = () => {
  const m = brand.meta;
  if (!m) return;
  if (m.windowTitle) document.title = m.windowTitle;

  const setLink = (selector, rel, href) => {
    if (!href) return;
    const els = document.querySelectorAll(selector);
    if (els.length === 0) {
      const el = document.createElement("link");
      el.setAttribute("rel", rel);
      el.setAttribute("href", href);
      document.head.appendChild(el);
    } else {
      els.forEach((el) => el.setAttribute("href", href));
    }
  };
  setLink('link[rel="icon"]', "icon", m.favicon);
  setLink('link[rel="apple-touch-icon"]', "apple-touch-icon", m.appleIcon);

  const setMeta = (name, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };
  setMeta("description", m.description);
  setMeta("apple-mobile-web-app-title", m.shortName);
};
applyBrandMeta();

// Branding PWA par espace (rôle) ET par marque : icône + nom à l'installation.
// Chaque marque a ses manifests + icônes dédiés ; sélection selon BRAND_KEY.
const PWA_ROLES = [
  { paths: ["/admin", "/install-admin"], role: "admin", titles: { asar: "ASAR Admin", dna: "DNA Admin" } },
  { paths: ["/courtier", "/install-courtier"], role: "courtier", titles: { asar: "ASAR Courtier", dna: "DNA Broker" } },
  { paths: ["/client", "/install-client"], role: "client", titles: { asar: "ASAR Client", dna: "DNA Client" } },
  { paths: ["/assisteur", "/install-assisteur"], role: "assisteur", titles: { dna: "DNA Partner" } },
];

const applyPwaBranding = () => {
  const path = window.location.pathname;
  const entry = PWA_ROLES.find((r) => r.paths.some((p) => path.startsWith(p)));
  if (!entry) return;
  const isDna = BRAND_KEY === "dna";
  const brandSlug = isDna ? "dna" : "asar";
  // Manifest (Android/Chrome : nom + icônes). ASAR = manifests historiques (sans suffixe).
  const manifest = document.getElementById("pwa-manifest");
  if (manifest) manifest.href = isDna ? `/manifest-${entry.role}-dna.json` : `/manifest-${entry.role}.json`;
  // iOS (Safari) : icône d'accueil + titre sous l'icône, par espace/marque
  const iconHref = `/icons/${entry.role}-${brandSlug}-icon-192x192.png`;
  document
    .querySelectorAll('link[rel="apple-touch-icon"]')
    .forEach((el) => el.setAttribute("href", iconHref));
  const title = entry.titles[brandSlug];
  const titleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (title && titleMeta) titleMeta.setAttribute("content", title);
};
applyPwaBranding();

const root = ReactDOM.createRoot(document.getElementById("root"));

// StrictMode désactivé pour éviter les double-renders et conflits DOM
root.render(<App />);
